module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.is_cart_with_estimate) ? _c('cart-component', {
    attrs: {
      "edit-order": _vm.editOrder,
      "nav-icon": _vm.navIcon
    }
  }) : _c('estimate-fixed', {
    attrs: {
      "edit-order": _vm.editOrder,
      "nav-icon": _vm.navIcon
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f8a7cc0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/hosted-pages/CartFixed.vue
// module id = 381
// module chunks = 42 66